export default __webpack_public_path__ + "static/mountains-xs-5c980aa0c00b7f3be9f21c1ec814a8d5.webp";